import React, { Component } from "react";
import { withDomains, RESTExecutor } from "../../../lib/domain";
import { Link } from "react-router-dom";
import {
  Typography,
  Table,
  Row,
  Button,
  Divider,
  Input,
  Spin,
  Tag,
  Badge,
  message,
  Alert,
  Space,
  Popconfirm,
  Drawer,
} from "antd";
import {
  showErrorInNotification,
  NetworkDelaySearch,
  overrideHeaderTitle,
  overrideHeaderBack,
  showSuccessInNotification,
  formatMoney,
} from "../../../lib/util";
import ErrorWrapper from "../../../lib/error_wrapper";
import { BasicHeader } from "../../../components/basic_header";
import { TransparentButton } from "../../../components/basic_items";
import { recon_quick_menu } from "../../../util/ui_util";
import  RefillAtmAddEdit from  './add_edit'
import RefillATMAEdit from './edit';
import RefillATMADetail from './detail';
const queryString = require("query-string");

const { Title, Paragraph, Text } = Typography;

class RefillAtmList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filter_query: {},
      selected_id: null,
      add_edit_modal: false,
      view_modal:false,
      selected_data: {},
    };

    this.listDataExecutor = RESTExecutor.list()
      .config({
        label: "atm_refill_list",
        params: {
          per_page: 100,
        },
      })
      .connect(props.domains.activity);


    this.delay_search = new NetworkDelaySearch();
  }

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj);
    }
    console.log(newData);
    this.setState(
      {
        [stateKey]: newData,
      },
      () => {
        typeof callback === "function" && callback();
      }
    );
  };

  render() {
    let list_data_resp = this.listDataExecutor.response();
    let list_data_data = list_data_resp.result || {};
    let rowsData = list_data_data.rows ?? [];
    let rowsMeta = list_data_resp.meta ?? {};


    const { filter_query,add_edit_modal,selected_id,view_modal } = this.state;

    return (
      <ErrorWrapper
        // error={list_data_resp}
        onReload={() => {
          this.listDataExecutor.execute();
        }}
      >
        <BasicHeader
          no_back
          title="Refill ATM"
          menu_items={recon_quick_menu}
          right={[
              <TransparentButton
                label="Add New Refill"
                className="cta-primary"
                hint="Add New Refill"
                onClick={() => {
                    this.setState({
                        add_edit_modal:true,
                        selected_id:null,
                        form_data:{}
                    })
                }}
              />
          ]}
        />

                <Drawer
                        title="Refill ATM"
                        placement="right"
                        closable={false}
                        width='50%'
                        destroyOnClose
                        onClose={() => {
                            this.setState({
                                add_edit_modal: false,
                                selected_id:null
                            });
                            this.listDataExecutor.execute()
                        }}
                        visible={add_edit_modal}
                    >
                        {selected_id?<RefillATMAEdit 
                        edit_id={selected_id}
                        onRefreshClose={() => {
                          this.setState({
                              add_edit_modal: false,
                              selected_id:null
                          });
                          this.listDataExecutor.execute()
                      }}
                        />:
                        <RefillAtmAddEdit
                        onRefreshClose={() => {
                                this.setState({
                                    add_edit_modal: false,
                                    selected_id:null
                                });
                                this.listDataExecutor.execute()
                            }}
                        />}
        </Drawer>
        <Drawer
                        title="Refill ATM"
                        placement="right"
                        closable={false}
                        width='50%'
                        destroyOnClose
                        onClose={() => {
                            this.setState({
                                view_modal: false,
                                selected_id:null
                            });
                        }}
                        visible={view_modal}
                    >
                        <RefillATMADetail
                        edit_id={selected_id}
                        />
        </Drawer>
        <div className="filter-card">
          <div
            className="filter-card-top"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              flexWrap: "nowrap",
            }}
          >
            <Input.Search
              placeholder="Search For"
              style={{}}
              autoFocus
              value={filter_query.query}
              onChange={(e) => {
                this.stateUpdater({
                  stateKey: "filter_query",
                  valueKey: "query",
                  value: e.target.value,
                  callback: () => {
                    this.delay_search.onSearch(() => {
                      this.props.history.push({
                        // pathname:"users",
                        search: queryString.stringify({
                          ...this.state.filter_query,
                          per_page: 100,
                          page: 1,
                        }),
                      });
                    });
                  },
                });
              }}
            />
          </div>
        </div>

        <div
          className="default-card"
          style={
            {
              // padding: 8
            }
          }
        >
          <Table
            // rowClassName='hand-cursor'
            className="main-table noHover"
            loading={list_data_resp.fetching}
            size="small"
            scroll={{ x: true }}
            pagination={{
              // simple: true,
              position: "bottom",
              onChange: (current, size) => {
                this.props.history.push({
                  search: queryString.stringify({
                    ...this.state.filter_query,
                    per_page: size,
                    page: current,
                  }),
                });
              },
              defaultCurrent: 1,
              current:
                rowsMeta.pagination &&
                parseInt(rowsMeta.pagination.split("/")[0]),
              // defaultPageSize: 20,
              pageSize: rowsMeta && rowsMeta.requested_count,

              total: rowsMeta && rowsMeta.total_count,
              showTotal: (total, range) =>
                `${formatMoney(range[0], 0)}-${formatMoney(
                  range[1],
                  0
                )} of ${formatMoney(total, 0)} items`,
            }}
            rowKey={(record) => record.id}
            columns={[
              // {
              //     title: <StarBorder titleAccess='Favourite' className='star-inactive hand-cursor'/>, dataIndex: 'favourite', key: 'favourite', render: (favourite, record) => {
              //         return <StarBorder
              //             className={favourite ? 'star-active hand-cursor' : 'star-inactive hand-cursor'}
              //             titleAccess="Toggle Favourite"

              //             onClick={() => {
              //                 if (favourite) {
              //                     this.unmark_favourite.forId(record.id).execute();
              //                 } else {
              //                     this.mark_favourite.forId(record.id).execute()
              //                 }
              //             }}
              //         />
              //     }
              // },
              {
                title: "Terminal ID",
                dataIndex: "terminal_id",
                key: "terminal_id",
                className: "bold-cell",
              },
              // {title:"Group",dataIndex:'group_name',key:'group_name'},
              {
                title: "Refill Date",
                dataIndex: "refill_date",
                key: "refill_date",
              },
              {
                title:"ATM Balance",
                dataIndex:'atm_balance',
                align:'right',
                key:'atm_balance',
                render:(val)=>formatMoney(val)
              },
              {
                title:"Total Replenished Balance",
                dataIndex:'total_bills_replenished',
                key:'total_bills_replenished',
                align:'right',
                render:(val)=>formatMoney(val)
              },
              {
                title:"Actions",
                dataIndex: 'id',
                key: 'actions',
                align:'center',
                render: (id, data) => {
                    return <div style={{
                        display:'flex',
                        flexDirection:'row',
                        alignItems:'center',
                        justifyContent:'flex-end'
                    }}> 
                        <Button type='link' onClick={() => {
                            // typeof onEditPressed === 'function' && onEditPressed(data);
                            this.setState({
                              view_modal:true,
                              selected_id:id
                            })
                        }}>View</Button>
                        <Divider type='vertical'/>
                        <Button type='link' onClick={() => {
                            // typeof onEditPressed === 'function' && onEditPressed(data);
                            this.setState({
                              add_edit_modal:true,
                              selected_id:id
                            })
                        }}>Edit</Button>
                    </div>
                }
              }
            ]}
            dataSource={rowsData}
          />
        </div>
      </ErrorWrapper>
    );
  }

  componentDidMount() {
    overrideHeaderTitle("Datatype List");
    overrideHeaderBack(null);
    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState(
      {
        filter_query: {
          per_page: 100,
          page: 1,
          ...new_filter_query,
        },
      },
      () => {
        this.listDataExecutor
          .config({
            params: {
              ...this.state.filter_query,
            },
          })
          .execute();
      }
    );
  }
  componentWillUnmount() {}
  componentWillReceiveProps(nextProps) {
    let new_filter_query = {};
    if (this.props.location.search !== nextProps.location.search) {
      const parsed = queryString.parse(nextProps.location.search);
      new_filter_query = parsed;
      this.setState(
        {
          filter_query: {
            per_page: 100,
            page: 1,
            ...new_filter_query,
          },
        },
        () => {
          this.listDataExecutor
            .config({
              params: {
                ...this.state.filter_query,
              },
            })
            .execute();
        }
      );
    } else {
      //   this.list_logs.execute()
    }
  }
}

export default withDomains(RefillAtmList, "allData", "activity");


